export default "__VITE_ASSET__12D2QpYu__"